import { Component, signal, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ThemeService } from './core/services/theme.service';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule],
  template: `<router-outlet></router-outlet>`,
  styleUrl: './app.scss',
  encapsulation: ViewEncapsulation.None,
})
export class App {
  private translate = inject(TranslateService);
  protected theme = inject(ThemeService);
  private iconRegistry = inject(MatIconRegistry);
  protected readonly title = signal('maintenanceOps');

  constructor() {
    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    this.translate.addLangs(['es', 'en', 'fr', 'pt']);
    const savedLang = localStorage.getItem('language') || 'es';
    this.translate.setDefaultLang('es');
    this.translate.use(savedLang);
    (window as any).globalTranslate = this.translate;
  }

  toggleLanguage() {
    const langs = this.translate.getLangs();
    const current = this.translate.currentLang || 'es';
    const currentIndex = langs.indexOf(current);
    const nextIndex = (currentIndex + 1) % langs.length;
    const next = langs[nextIndex];
    this.translate.use(next);
    localStorage.setItem('language', next);
  }
}


